export function formatToISODate(date: Date) {
  // YYYY-MM-DD using local date components to avoid timezone issues
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/**
 * Converts a date-only string (YYYY-MM-DD) to a local datetime string by
 * appending T00:00:00. This prevents new Date() from interpreting date-only
 * strings as UTC midnight, which shifts to the previous day in timezones
 * behind UTC (e.g., all of the Americas).
 */
export function toLocalDateValue(
  value: string | null | undefined
): string | undefined {
  if (!value) return undefined;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return `${value}T00:00:00`;
  }
  return value;
}

export function formatToUSDate(date: Date) {
  // MM/DD/YYYY
  const formatter = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  return formatter.format(date);
}

export function formatToShortDate(date: Date) {
  // example output: "Dec 2, 2025"
  const formatter = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  return formatter.format(date);
}

export function subtractYears(date: Date, years: number) {
  return new Date(date.getFullYear() - years, date.getMonth(), date.getDate());
}

export function addYears(date: Date, years: number) {
  return new Date(date.getFullYear() + years, date.getMonth(), date.getDate());
}

export function addDays(date: Date, days: number) {
  return new Date(date.getTime() + days * 24 * 60 * 60 * 1000);
}
